import { generate } from 'randomstring';
export const randId = generate;